import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import qs from 'query-string';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* getPopup(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.GET_POPUP, API.POST, action.params);

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({ type: types.POPUPS_REQUEST_SUCCEEDED, data: response.data });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({ type: types.POPUPS_REQUEST_FAILED, error: response });
    } else {
      yield put({ type: types.POPUPS_REQUEST_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.POPUPS_REQUEST_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchGetPopupsData() {
  yield takeLatest(types.POPUPS_REQUESTED, getPopup);
}

function* deletePopup(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.DELETE_POPUP,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      const parsedRequestBody = qs.parse(action.params.body);
      yield put({
        type: types.DELETE_POPUP_REQUEST_SUCCEEDED,
        popup_id: parsedRequestBody.popup_id
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({ type: types.DELETE_POPUP_REQUEST_FAILED, error: response });
    } else {
      yield put({ type: types.DELETE_POPUP_REQUEST_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.DELETE_POPUP_REQUEST_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchDeletePopupData() {
  yield takeLatest(types.DELETE_POPUP_REQUESTED, deletePopup);
}
